import PropTypes from 'prop-types';
import React from 'react';

import messages from './messages';
import Form from '../../../../components/Form';

import '../styles.css';

const ScholarshipAvailability = ({ onChange, initialValue, formatMessage }) => (
  <div
    styleName="transfer-website-container"
    data-cy="Premium-Hem-Transfer-Scholarship-Availability-Container"
  >
    <p>{formatMessage(messages.scholarshipAvailabilityLabel)}</p>
    <Form>
      <Form.Radio
        value="yes"
        label="Yes"
        checked={initialValue.value === 'yes'}
        onChange={(e, { value }) => onChange(e, { value })}
        data-cy="Premium-Hem-Transfer-Scholarship-Availability-RadioField-Yes"
      />
      <Form.Radio
        value="no"
        label="No"
        checked={initialValue.value === 'no'}
        onChange={(e, { value }) => onChange(e, { value })}
        data-cy="Premium-Hem-Transfer-Scholarship-Availability-RadioField-No"
      />
    </Form>
  </div>
);

ScholarshipAvailability.propTypes = {
  onChange: PropTypes.func,
  formatMessage: PropTypes.func,
  initialValue: PropTypes.object,
};
export default ScholarshipAvailability;
